import type { FeedPost } from "@/lib/feed";

/** Descriptions use only public style and furniture snapshots, never private room answers. */
export function feedTitle(post: Pick<FeedPost, "design_style" | "products">): string {
  const seen = new Set<string>();
  const pieces: string[] = [];
  for (const p of post.products) {
    const name = (p.furniture?.item || "").trim().toLowerCase();
    if (name && !seen.has(name)) { seen.add(name); pieces.push(name); }
    if (pieces.length === 2) break;
  }
  const style = post.design_style?.trim();
  const lead = style ? `${style} look` : "Curated look";
  if (pieces.length === 0) return lead;
  return `${lead} with ${pieces.join(" and ")}`;
}
